"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEventIncidenceSummaryEntity = exports.DisplayEventIncidenceSlotSummaryEntity = void 0;
class DisplayEventIncidenceSlotSummaryEntity {
    date;
    hour;
    totalEvents;
    incidentCount;
    criticalCount;
    affectedDisplays;
    bySeverity;
    topTypes;
}
exports.DisplayEventIncidenceSlotSummaryEntity = DisplayEventIncidenceSlotSummaryEntity;
class DisplayEventIncidenceSummaryEntity {
    displayIds;
    from;
    to;
    slots;
}
exports.DisplayEventIncidenceSummaryEntity = DisplayEventIncidenceSummaryEntity;
